<template>
  <div>
    <div class="tree-selects-more">
      <template v-for="(type, i) in types">
        <div class="tab-wrap" :key="type">
          <a
            v-for="(o, index) in selections[type]"
            :key="index"
            :class="['tab', { active: selectedIndexs[type] === index }]"
            :href="o.href || 'javascript:;'"
            v-stat="o.stat"
            @click.prevent="handleChangeIndex(i, type, index)"
          >
            <span>{{ o.name }}</span>
          </a>
        </div>
      </template>
    </div>
    <buttons
      v-stat="resetText"
      :btns="[{ label: resetText, onClick: reset }]"
    />
  </div>
</template>

<script>
import buttons from 'app/web/component/consult/listCommon/buttons.vue'
export default {
  components: { buttons },
  props: {
    // 数据源 多层子级用list嵌套 [ { list: [] } ]
    list: {
      type: Array
    },
    // 对应层级key
    types: {
      type: Array,
      default: () => []
    },
    resetText: {
      type: String,
      default: '不限城市'
    },
    initFun: {
      type: Function
    }
  },
  data() {
    return {
      selectedIndexs: {},
      selections: {}
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      if (this.initFun && typeof this.initFun === 'function') {
        const [selectedIndexs, selections] = this.initFun()
        this.selectedIndexs = selectedIndexs
        this.selections = selections
        return
      }
      this.types.reduce((prev, cur) => {
        this.$set(this.selectedIndexs, cur, 0)
        let list = prev ? this.selections[prev][0]?.list || [] : this.list
        this.$set(this.selections, cur, list)
        return cur
      }, undefined)
    },
    handleChangeIndex(level, curType, index) {
      const selectedIndexs = JSON.parse(JSON.stringify(this.selectedIndexs))
      this.types.map((type, i) => {
        if (level > i) return
        if (level < i) return delete selectedIndexs[type]
        selectedIndexs[type] = index
      })
      this.$set(this, 'selectedIndexs', selectedIndexs)

      if (level === this.types.length - 1) return this.emitChange()
      // 非最后一层 需要处理子层
      this.$set(
        this.selections,
        this.types[level + 1],
        this.selections[curType][index]?.list
      )
      // this.types.slice(level + 1).reduce((prev, cur, i) => {
      //   // this.$set(this.selectedIndexs, cur, 0)
      //   this.$set(
      //     this.selections,
      //     cur,
      //     this.selections[prev][i ? 0 : index]?.list
      //   )
      //   return cur
      // }, curType)
    },
    reset() {
      this.init()
      this.emitChange(true)
    },
    emitChange(reset) {
      const data = {}
      this.types.forEach(type => {
        data[type] = reset
          ? ''
          : this.selections[type][this.selectedIndexs[type]].value
      })
      this.$emit('change', data)
    }
  }
}
</script>

<style lang="scss" scoped>
.tree-selects-more {
  font-size: 30px;
  display: flex;
  width: 100%;
  .no-limit-city {
    position: absolute;
    bottom: 30px;
    right: 30px;
    width: 196px;
    height: 56px;
    color: #fff;
    z-index: 13;
    background-color: #718aff;
    border-radius: 8px;
    text-align: center;
    line-height: 56px;
    font-size: 26px;
  }

  .tab-wrap {
    width: 100%;
    overflow: scroll;
    overflow-x: hidden;
    -webkit-overflow-scrolling: touch;
    @include flex(column, flex-start, center);
    height: 800px;
    background-color: #fff;
    &:first-child {
      max-width: 200px;
      .tab span {
        padding-left: 32px;
        margin: 0;
      }
    }
    .tab {
      display: block;
      width: 100%;
      height: 80px;
      line-height: 90px;
      color: #6c798c;
      span {
        display: block;
        // width: 80%;
        padding-left: 48px;
        margin: 0 auto;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        font-size: 28px;
      }
      &.active span {
        color: #718aff;
      }
    }
    &:first-child {
      height: 900px;
      background: #f2f4ff;
      .tab {
        color: #6c798c;
        &.active {
          background-color: #fff;
        }
      }
    }
  }
}
</style>
